import { Box, Icon, T } from '@veracity/vui'

import { CalculationStates } from '@/interfaces'
import { calculationStatusDictionary } from '@/utils'

const calculationIconDict = {
  [CalculationStates.NotSet]: 'falFile',
  [CalculationStates.InProgress]: 'falHourglass',
  [CalculationStates.Finished]: 'falCheckCircle',
  [CalculationStates.Error]: 'falExclamationCircle',
  [CalculationStates.Preprocessing]: 'falHourglass',
  [CalculationStates.Canceled]: 'falExclamationCircle'
}

interface Props {
  status: CalculationStates
}

export const ProjectDetailsScenarioCardStatus = ({ status }: Props) => (
  <Box gap={1}>
    <Icon name={calculationIconDict[status]} pathFill="seaBlue.28" />
    <T>{calculationStatusDictionary[status] || 'Unknown'}</T>
  </Box>
)
